import { ArticleController as Article } from "./controller";

export default Article;
